<template>
  <div>
    <Editor :account-id="accountId" />
  </div>
</template>

<script>
import Editor from './components/Editor.vue';

export default {
  components: {
    Editor,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
